import React from 'react';

const LanguageSwitcher = ({ currentLanguage }) => {
  // Функция для изменения языка
  const changeLanguage = (lang) => {
    // Получаем текущий путь без языкового префикса
    let pathWithoutLang = window.location.pathname
      .replace(/^\/[a-z]{2}/, ''); // Удаляем языковой префикс если есть
    
    // Если путь пустой или только слеш, не добавляем его к языковому префиксу
    if (pathWithoutLang === '' || pathWithoutLang === '/') {
      pathWithoutLang = '';
    }
    
    // Устанавливаем cookie с языком (django_language - стандартное имя для Django)
    document.cookie = `django_language=${lang};path=/;max-age=31536000`;
    
    // Перенаправляем на тот же путь, но с новым языковым префиксом
    window.location.href = `/${lang}${pathWithoutLang}`;
  };

  return (
    <div className="language-switcher">
      <button 
        className={`lang-btn ${currentLanguage === 'en' ? 'active' : ''}`} 
        onClick={() => changeLanguage('en')}
      >
        EN
      </button>
      <button 
        className={`lang-btn ${currentLanguage === 'ru' ? 'active' : ''}`} 
        onClick={() => changeLanguage('ru')}
      >
        RU
      </button>
      <button 
        className={`lang-btn ${currentLanguage === 'ka' ? 'active' : ''}`} 
        onClick={() => changeLanguage('ka')}
      >
        KA
      </button>
    </div>
  );
};

export default LanguageSwitcher;
